<template>
  <megabit-base-dialog :show-dialog="true" :width="800">
    <template v-slot:body>
      <v-card color="rgba(0, 0, 0, 0.8)">
        <v-card-title class="align-self-center">
          <span class="text-h6 white--text">Cadastro de Cidades (alt+r)</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense>
              <v-col cols="4" md="4" lg="2">
                <c-input
                  label="Código"
                  placeholder="Código"
                  :maxLength="10"
                  type="Number"
                  :isRequired="true"
                  v-model.trim="form.codigo"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8" md="8" lg="11">
                <c-input
                  label="Cidade"
                  placeholder="Digite o nome da cidade"
                  :minLength="3"
                  :maxLength="40"
                  :isRequired="true"
                  v-model.trim="form.descricao"
                />
              </v-col>
              <v-col cols="4" md="4" lg="1">
                <template v-if="!!estados">
                  <c-input
                    v-model="form.uf"
                    label="UF"
                    placeholder="Digite UF"
                    :maxLength="2"
                  />
                </template>
                <template v-else>
                  <c-select
                    :lista="estados"
                    :item.sync="form.uf"
                    itemText="UF"
                    itemValue="UF"
                    rotulo="UF"
                  />
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="3" lg="3">
                <c-input
                  label="Código Municipio"
                  placeholder="Código Municipio"
                  :maxLength="10"
                  type="Number"
                  v-model.trim="form.codigoMunicipio"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons @submitForm="submitForm()" @goBack="goBack()" />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelect from '@/components/shared/base-input/BaseSelect'
import FormButtons from '@/components/shared/base-buttons/FormButtons';
import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import { mapActions } from 'vuex'

export default {
  mixins: [formRegisterMixin],
  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    cSelect,
    FormButtons,
  },
  data: () => ({
    form: {
      codigo: '',
      descricao: '',
      uf: '',
      codigoMunicipio: '',
    },
  }),
  computed: {
    estados() {
      // precisa retornar uma lista de estados, verificar com deonir
      return []
    },
  },
  methods: {
    ...mapActions({
      insert: 'cityModule/insertCity',
      update: 'cityModule/updateCity',
      getCity: 'cityModule/getCity',
    }),

    async setData() {
      if (this.$route.params && this.$route.params.id > 0) {
        let city = await this.getCity(this.$route.params.id)
        this.form = {
          ...city,
        }
        this.isUpdate = !this.isUpdate
      }
    },
  },
  mounted() {
    this.setData()
  },
}
</script>
